import z from "zod";
import { annotationBoxStatsSchema } from "../analytics/analytics.schema";
import { storedErrorReportSchema, storedErrorSchema } from "../errors";
import { PreAnnotateModelTypeEnum } from "../preAnnotateSettings/preAnnotateSettings.schema";
export var ConfidenceReportStatusEnum;
(function (ConfidenceReportStatusEnum) {
    ConfidenceReportStatusEnum["PENDING"] = "PENDING";
    ConfidenceReportStatusEnum["RUNNING"] = "RUNNING";
    ConfidenceReportStatusEnum["DONE"] = "DONE";
    ConfidenceReportStatusEnum["ERROR"] = "ERROR";
    ConfidenceReportStatusEnum["CANCELLED"] = "CANCELLED";
})(ConfidenceReportStatusEnum || (ConfidenceReportStatusEnum = {}));
export var ConfidenceReportGtGeometryEnum;
(function (ConfidenceReportGtGeometryEnum) {
    ConfidenceReportGtGeometryEnum["RECTANGLE"] = "RECTANGLE";
    ConfidenceReportGtGeometryEnum["POLYGON"] = "POLYGON";
})(ConfidenceReportGtGeometryEnum || (ConfidenceReportGtGeometryEnum = {}));
export const runConfidenceReportSchema = z.object({
    modelId: z.number().int().positive(),
    conf: z.number().min(0).max(1),
    matchIou: z.number().min(0).max(1).default(0.5),
    gtGeometry: z.enum(ConfidenceReportGtGeometryEnum),
});
export const confidenceReportPerClassStatSchema = z.object({
    labelId: z.number(),
    name: z.string(),
    color: z.string(),
    confidence: annotationBoxStatsSchema,
    iou: annotationBoxStatsSchema.nullable(),
    detectionCount: z.number(),
    tpCount: z.number(),
});
export const confidenceReportSchema = z.object({
    id: z.number(),
    projectId: z.number(),
    modelId: z.number().nullable(),
    modelName: z.string().nullable().optional(),
    modelType: z.enum(PreAnnotateModelTypeEnum).nullable().optional(),
    conf: z.number(),
    matchIou: z.number().default(0.5),
    gtGeometry: z.enum(ConfidenceReportGtGeometryEnum),
    status: z.enum(ConfidenceReportStatusEnum),
    processed: z.number(),
    total: z.number(),
    ...storedErrorSchema.shape,
    perClassStats: confidenceReportPerClassStatSchema.array().nullable(),
    overallPrecision: z.number().nullable().optional(),
    overallRecall: z.number().nullable().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const confidenceReportRegionInputSchema = z.object({
    labelId: z.number(),
    score: z.number(),
    geometry: z.enum(ConfidenceReportGtGeometryEnum),
    iou: z.number().nullable().optional(),
    matchedAnnotationId: z.number().nullable().optional(),
    x: z.number().optional(),
    y: z.number().optional(),
    width: z.number().optional(),
    height: z.number().optional(),
    value: z.tuple([z.number(), z.number()]).array().optional(),
});
export const confidenceReportRegionResponseSchema = z.object({
    id: z.number(),
    label: z.object({
        id: z.number(),
        name: z.string(),
        color: z.string(),
    }),
    score: z.number(),
    geometry: z.enum(ConfidenceReportGtGeometryEnum),
    iou: z.number().nullish(),
    matchedAnnotationId: z.number().nullish(),
    x: z.number().nullish(),
    y: z.number().nullish(),
    width: z.number().nullish(),
    height: z.number().nullish(),
    value: z.tuple([z.number(), z.number()]).array().nullish(),
});
export const confidenceReportTaskResultSchema = z.object({
    taskId: z.number(),
    meanConfidence: z.number().nullable(),
    meanIou: z.number().nullable(),
    precision: z.number().nullable(),
    recall: z.number().nullable(),
    regions: confidenceReportRegionInputSchema.array().default([]),
});
export const confidenceReportProgressSchema = z.object({
    processed: z.number(),
    total: z.number(),
    taskResults: confidenceReportTaskResultSchema.array(),
});
export const confidenceReportCompleteSchema = z.object({
    perClassStats: confidenceReportPerClassStatSchema.array(),
    overallPrecision: z.number().nullable(),
    overallRecall: z.number().nullable(),
});
export const confidenceReportErrorSchema = storedErrorReportSchema;
//# sourceMappingURL=confidence-report.schema.js.map